(() => {
  function setup() {
    document.querySelectorAll('[data-lz-mobile-buy]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = document.getElementById('product_form_' + root.dataset.productId);
      const input = form?.querySelector('[name="quantity"]');
      const add = form?.querySelector('[name="add"]');
      if (!input || !add) return;
      const minimum = Number(root.dataset.minimum);
      const variants = JSON.parse(root.querySelector('[data-mobile-variants]').textContent);
      const bar = root.querySelector('.lz-sticky-buy');
      document.body.append(bar);
      const button = bar.querySelector('[data-sticky-add]');
      const summary = bar.querySelector('[data-sticky-total]');
      const money = cents => new Intl.NumberFormat('en-HK', {style:'currency',currency:root.dataset.currency || 'HKD'}).format(cents/100);
      const update = () => {
        const variant = variants.find(v => String(v.id) === form.querySelector('[name="id"]')?.value);
        const quantity = Number(input.value);
        const valid = Number.isInteger(quantity) && quantity >= Math.max(1,minimum);
        const units = minimum > 0 ? quantity + 'g' : (quantity===1 ? root.dataset.itemLabel : root.dataset.itemsLabel).replace('[count]',quantity);
        const text = units + ' ' + root.dataset.totalLabel + ': ' + money((variant?.price || 0) * (quantity || 0));
        summary.textContent = text;
        const total = form.querySelector('#lz-total');
        if (total) total.textContent = text;
        button.disabled = !valid || !variant?.available || add.disabled;
        root.querySelectorAll('[data-weight]').forEach(b => b.setAttribute('aria-pressed',String(Number(b.dataset.weight)===quantity)));
      };
      root.querySelectorAll('[data-weight]').forEach(b => b.addEventListener('click', () => {
        input.value = b.dataset.weight;
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        update();
      }));
      form.addEventListener('input',update);
      form.addEventListener('change',() => setTimeout(update,0));
      button.addEventListener('click',() => {update();if(!button.disabled) add.click();});
      new MutationObserver(update).observe(add,{attributes:true,attributeFilter:['disabled']});
      const position = () => {
        update();
        const rect = add.getBoundingClientRect();
        bar.hidden = !(window.matchMedia('(max-width:767px)').matches && rect.bottom < 0);
        const preview = document.getElementById('PBarNextFrame');
        bar.style.bottom = (preview ? 88 : 0) + 'px';
      };
      document.addEventListener('scroll',position,{passive:true,capture:true});
      new IntersectionObserver(position).observe(add);
      window.addEventListener('resize',position);
      window.addEventListener('load',() => {update();position();});
      update();position();
    });
  }
  const invalid = input => {
    const row = input.closest('[data-lz-cart-minimum]');
    const min = Number(row?.dataset.lzCartMinimum);
    if (!(min > 0)) return false;
    const q = Number(input.value);
    const bad = !Number.isInteger(q) || q < min;
    input.setCustomValidity(bad ? row.dataset.lzCartError : '');
    let message = input.closest('.cart--item--quantity').querySelector('.lz-quantity-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'lz-quantity-error';
      message.setAttribute('role','alert');
      input.closest('.cart--item--quantity').append(message);
    }
    message.textContent = bad ? row.dataset.lzCartError : '';
    input.setAttribute('aria-invalid',String(bad));
    return bad;
  };
  ['input','change','keyup'].forEach(type => document.addEventListener(type,event => {
    const input = event.target.closest?.('.cart--quantity--input');
    if (!input) return;
    if(invalid(input)) {
      event.stopImmediatePropagation();
      if(type==='change') input.reportValidity();
    } else {
      const unit=input.closest('.cart--item')?.querySelector('[data-cart-unit]');
      if(unit) unit.textContent=input.value+(unit.dataset.cartUnit==='grams'?'g':(Number(input.value)===1?' item':' items'));
    }
  },true));
  document.addEventListener('click',event => {
    const minus = event.target.closest('.cart--item .minus');
    if (minus) {
      const row=minus.closest('[data-lz-cart-minimum]');
      const input=row?.querySelector('.cart--quantity--input');
      const minimum=Number(row?.dataset.lzCartMinimum);
      if(minimum>0 && Number(input.value)-1<minimum){event.preventDefault();event.stopImmediatePropagation();input.setCustomValidity(row.dataset.lzCartError);let message=row.querySelector('.lz-quantity-error');if(!message){message=document.createElement('p');message.className='lz-quantity-error';message.setAttribute('role','alert');input.closest('.cart--item--quantity').append(message);}message.textContent=row.dataset.lzCartError;input.reportValidity();}
    }
    if (event.target.closest('.cart--checkout-button')) {
      const form=event.target.closest('form');
      const bad=[...form.querySelectorAll('.cart--quantity--input')].find(invalid);
      if(bad){event.preventDefault();event.stopImmediatePropagation();bad.reportValidity();}
    }
  },true);
  document.addEventListener('submit',event => {
    if(!event.target.matches('.cart--form'))return;
    const bad=[...event.target.querySelectorAll('.cart--quantity--input')].find(invalid);
    if(bad){event.preventDefault();event.stopImmediatePropagation();bad.reportValidity();}
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();

(() => {
  const init = () => {
    let lineCount = null;
    const paint = () => {
      if(lineCount === null) return;
      document.querySelectorAll('.cart--external--total-items').forEach(el=>{if(el.textContent!==String(lineCount))el.textContent=String(lineCount);});
      document.querySelectorAll('.number-wrapper[data-item-count]').forEach(el=>el.dataset.itemCount=String(lineCount));
    };
    let refreshId=0;
    const refresh = async () => {
      const id=++refreshId;
      try {const response=await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{cache:'no-store'});if(!response.ok)return;const cart=await response.json();if(id!==refreshId)return;lineCount=cart.items.length;paint();}catch(e){}
    };
    refresh();
    document.querySelectorAll('.number-wrapper').forEach(el=>new MutationObserver(paint).observe(el,{childList:true,subtree:true,characterData:true}));
    const root=document.querySelector('[data-lz-mobile-buy]');
    const form=root && document.getElementById('product_form_'+root.dataset.productId);
    const help=form?.querySelector('.lz-purchase-help');
    if(help && form)form.append(help);
    const notice=form?.querySelector('.lz-add-confirm');
    if(notice){document.body.append(notice);notice.querySelector('[data-keep-shopping]').addEventListener('click',()=>{notice.hidden=true;document.querySelector('.off-canvas--close')?.click();form?.querySelector('[name="add"]')?.focus();});}
    let requested=null;
    form?.addEventListener('submit',()=>{requested=Number(form.querySelector('[name="quantity"]')?.value);},true);
    form?.querySelector('[name="add"]')?.addEventListener('click',()=>{requested=Number(form.querySelector('[name="quantity"]')?.value);},true);
    if(window.jQuery)window.jQuery(document).on('ajaxComplete.lzMobile',(_event,xhr,settings)=>{
      const path=new URL(settings.url,location.href).pathname;
      if(!/\/cart\/(add|change|update|clear)(\.js)?$/.test(path))return;
      refresh();
      if(!notice || requested===null || !/\/cart\/add(\.js)?$/.test(path))return;
      let result;try{result=JSON.parse(xhr.responseText);}catch(e){result=null;}
      const ok=xhr.status>=200 && xhr.status<300 && result && (result.id || result.items);
      const quantity=requested;requested=null;
      const unit=Number(root.dataset.minimum)>0 ? quantity+'g' : (quantity===1?root.dataset.itemLabel:root.dataset.itemsLabel).replace('[count]',quantity);
      notice.querySelector('[data-add-message]').textContent=ok ? root.dataset.added+' '+root.dataset.title+' — '+unit : root.dataset.error;
      notice.querySelector('a').hidden=!ok;
      notice.hidden=false;
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(() => {
 const setup=()=>{
  if(document.querySelector('.collection .product-grid--root'))document.addEventListener('click',event=>{
   const link=event.target.closest('.product-grid--root a[href]');if(!link)return;
   const destination=new URL(link.href,location.href);
   if(!destination.pathname.includes('/products/'))return;
   try{sessionStorage.setItem('lz-collection-return',JSON.stringify({product:destination.pathname.split('/products/')[1],url:location.pathname+location.search}));}catch(e){}
  });
  const back=document.querySelector('.lz-back-collection[data-collection-url]');
  if(back)try{const saved=JSON.parse(sessionStorage.getItem('lz-collection-return'));const path=location.pathname.split('/products/')[1];if(saved?.product===path){const url=new URL(saved.url,location.origin);const base=back.dataset.collectionUrl;if(url.origin===location.origin && (url.pathname===base || url.pathname.startsWith(base+'/')))back.href=url.pathname+url.search;}}catch(e){}
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
